'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'calendar-days';
var width = 448;
var height = 512;
var aliases = ["calendar-alt"];
var unicode = 'f073';
var svgPathData = 'M128 8l0-8L112 0l0 8 0 56L16 64 0 64 0 80l0 96 0 16 0 96 0 16 0 96 0 16 0 80 0 16 16 0 416 0 16 0 0-16 0-80 0-16 0-96 0-16 0-96 0-16 0-96 0-16-16 0-96 0 0-56 0-8L320 0l0 8 0 56L128 64l0-56zM432 288l-128 0 0-96 128 0 0 96zM288 192l0 96-128 0 0-96 128 0zm-144 0l0 96L16 288l0-96 128 0zM16 304l128 0 0 96L16 400l0-96zm0 112l128 0 0 80L16 496l0-80zm144 80l0-80 128 0 0 80-128 0zm144 0l0-80 128 0 0 80-128 0zm128-96l-128 0 0-96 128 0 0 96zM112 80l0 40 0 8 16 0 0-8 0-40 192 0 0 40 0 8 16 0 0-8 0-40 96 0 0 96L16 176l0-96 96 0zM288 400l-128 0 0-96 128 0 0 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalendarDays = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;